import React, { useState, useEffect } from "react";
import axios from "axios";

const OurTeam = () => {
  const [messages, setMessages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTeamData = async () => {
      try {
        const response = await axios.get("https://ethiccraft.org/backend/team/read_isShown.php");
        // const records = response.data?.records || [];
        const data = response.data;

        // Filter for entries with college === "main"
        const filteredData = data
          .filter((item) => item.college === "main")
          .map((item) => ({
            image: `https://ethiccraft.org/${item.image}`,
            name: item.name,
            message: item.description,
            author: item.designation,
          }));

        setMessages(filteredData);
      } catch (err) {
        console.error("Error fetching team data:", err);
        setError("Failed to load team data.");
      }
    };

    fetchTeamData();
  }, []);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? messages.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === messages.length - 1 ? 0 : prevIndex + 1
    );
  };

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (messages.length === 0) {
    return <div className="loading-message">Loading team members...</div>;
  }

  return (
    <div className="Team-container">
      <div
        className="Team-profile-card"
        style={{ backgroundImage: `url(${messages[currentIndex].image})` }}
      >
        <div className="profile-overlay">
          <h2 className="profile-title">
            <span className="gold-text">{messages[currentIndex].name.split(" ")[0]}</span>
            {messages[currentIndex].name.slice(messages[currentIndex].name.split(" ")[0].length)}
          </h2>
        </div>
        <button className="arrow left-arrow" onClick={prevSlide}>
          &#8592;
        </button>
        <button className="arrow right-arrow" onClick={nextSlide}>
          &#8594;
        </button>
      </div>

      <div className="msg-content">
        <h1 className="ourteam-title">Our Team</h1>
        <p className="msg-text">{messages[currentIndex].message}</p>
        <div className="author-section">
          <h3>
            <p className="msg-author">{messages[currentIndex].author}</p>
          </h3>
          {/* <p className="see-me">See me</p> */}
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
